import * as React from "react";
import {
  useDispatch,
  useMappedState
} from "redux-react-hook";
import styled, { css } from "styled-components";

import Grid from "src/library/components/Hedron";
import { BrandSplitView } from "src/library/components/BrandSplitView";
import { Button } from "src/library/components/Button";
import { PageErrorDetails } from "src/library/components/Errors";
import { Link } from "src/library/components/Link";
import { Text } from "src/library/components/Text";
import { Logo } from "src/core/shared/components/Logo";
import type { IStore } from "src/core/shared/store";
import { setGlobalError } from "src/core/shared/store/global/global.actions";
import { PageProps } from "src/pages/Router/routes";

/**
 * 404 Not Found View
 *
 * @param {*} { history }
 * @returns
 */
const NotFound: React.ReactFCWithChildren<PageProps<unknown>> = () => {
  const { error, role } = useMappedState((store: IStore) => ({
    error: store.global.error,
    role: store.global.role
  }));

  const dispatch = useDispatch();
  const redirect = role && role.type === "admin" ? role.code === "van-sales-admin" ? "/van-sales" : "/admin/dashboard" : "/dashboard";

  React.useEffect(() => {
    if (!error) {
      dispatch(setGlobalError({
        status: 404,
        type: "not_found",
        message: "No page exists at this url!",
        title: "Page not found!"
      }));
    }
  }, []);

  return (
    <BrandSplitView>
      <NotFoundInner>
        <Grid.Box className="logo-wrapper">
          <Logo type="dark" />
        </Grid.Box>

        <PaddedContainer>
          <Text
            weight="bold"
            letterSpacing="big"
            fontSize="h1"
          >
            404
          </Text>
        </PaddedContainer>

        <Grid.Box>
          <Text
            color="secondary"
            fontSize="p"
          >
            This page can't be found
          </Text>
        </Grid.Box>

        <PaddedContainer>
          <Button>
            <Link
              color="white"
              to={redirect}
            >
              Go to dashboard
            </Link>
          </Button>
        </PaddedContainer>

        <PageErrorDetails error={error} />
      </NotFoundInner>
    </BrandSplitView>
  );
};

const PaddedContainer = styled(Grid.Box)`
  ${({ theme }) =>
    css`
      padding-top: ${theme.spacing.padding.xl};
    `};
`;

const NotFoundInner = styled(Grid.Bounds)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  ${({ theme }) =>
    css`
      padding: ${theme.spacing.padding.xl};
      padding-bottom: 0;
  `};

  .logo-wrapper {
    max-width: 400px;
  }
`;

export default NotFound;
